
export function AIDetectionSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                UK-Trained AI That Understands Local Threats
              </h2>
              <p className="text-lg text-gray-400 mb-8 leading-relaxed">
                Our machine learning models are specifically trained on UK phishing and smishing datasets, making them highly effective at detecting regional attack patterns that generic solutions miss.
              </p>
              
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-4 mt-1">
                    <i className="ri-search-line text-blue-400"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-white mb-2">Natural Language Processing</h3>
                    <p className="text-gray-400">Advanced NLP analyzes message content, context, and sender behavior to identify sophisticated social engineering attempts.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-4 mt-1">
                    <i className="ri-link text-blue-400"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-white mb-2">Malicious URL Detection</h3>
                    <p className="text-gray-400">Real-time scanning of links and attachments against our continuously updated threat database.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-4 mt-1">
                    <i className="ri-time-line text-blue-400"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-white mb-2">Instant Response</h3>
                    <p className="text-gray-400">Threats are blocked within milliseconds, preventing any interaction with malicious content.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <img
                src="https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=600&h=500&fit=crop&crop=center"
                alt="AI threat detection interface"
                className="w-full h-auto rounded-xl shadow-lg object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
